<template>
    <div>
        <main class="main-content main-content-sports main-live" v-if="page">
            <div class="container-fluid container-sports --green">
                <div class="row">
                    <div class="col-12">
                        <p class="sports-title"><strong>Esportes</strong></p>
                    </div>
                </div>
            </div>

            <div class="container container-banner">
                <div class="row">
                    <div class="col-12">
                        <div id='div-gpt-ad-1603501550614-0'></div>
                    </div>
                </div>
            </div>

            <div class="live-scoreboard">
                <div class="container">

                    <p class="live-scoreboard--title">
                        <a @dblclick="show_form=true">{{page.championship.name}}</a>
                    </p>

                    <div class="live-scoreboard-panel">
                        <div class="row">
                            <div class="col-4 score-board-panel--team">
                                <div class="row responsive-scoreboard-team--area">
                                    <div class="col-sm-12 col-md-8">
                                        <p class="team-title">{{page.team_home.initials}}</p>
                                    </div>

                                    <div class="col-sm-12 col-md-4">
                                        <div class="team-badge">
                                            <img v-if="page.team_home.logo" :src="utils.image(page.team_home.logo.file, 46, 45)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-4 score-board-panel--score">
                                <span>{{page.score_home}}</span>
                                <span class="versus">x</span>
                                <span>{{page.score_visitor}}</span>
                            </div>
                            
                            <div class="col-4 score-board-panel--team">
                                <div class="row score-board-panel--row">
                                    <div class="col-sm-12 col-md-4">
                                        <div class="team-badge">
                                            <img v-if="page.team_visitor.logo" :src="utils.image(page.team_visitor.logo.file, 46, 45)">
                                        </div>
                                    </div>

                                    <div class="col-sm-12 col-md-8">
                                        <p class="team-title">{{page.team_visitor.initials}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="player" class="container-fluid container-live-wrapper" v-if="videos.length">
                <div class="container">
                    <div class="row" v-if="video_destaque">
                        <div class="col-12">
                            <div class="container-live-wrapper__video">
                                <iframe 
                                    allowfullscreen="allowFullScreen" 
                                    :src="`https://www.youtube.com/embed/${video_destaque.video_id}?autoplay=${autoplay}&amp;ecver=1&amp;iv_load_policy=3&amp;rel=0&amp;showinfo=0&amp;yt:stretch=16:9&amp;autohide=1&amp;color=red&amp;width=560&amp;width=560`" 
                                    width="100%" 
                                    height="450" 
                                    allowtransparency="true" 
                                    frameborder="0">
                                </iframe>
                            </div>
                        </div>
                    </div>
                    <div class="row swiper-row">
                        <div class="slide">
                            <div class="swiper-button-prev swiper-button-prev--live-slider"></div>
                            <div class="swiper-button-next swiper-button-next--live-slider"></div>
                            <div
                                v-if="videos.length"
                                class="swiper-container row-live-slider">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" v-for="video in videos" :key="video.id">
                                        <a
                                            data-url="https://www.youtube.com/watch?v=5iNxpdemlCA"
                                            href="javascript:;"
                                            target="_self"
                                            @click="play(video)"
                                            class="noticies-item noticies-item__live-video">
                                            <div class="noticies-item--image">
                                                <img v-if="video.thumbnail" :src="utils.image(video.thumbnail.file, 256,168)" alt="">
                                            </div>
                                            <div class="noticies-item--info noticies-item--info-video">
                                                <p class="noticies__title noticies__title--small noticies__title--white">
                                                    <strong>{{video.caption || video.title }}</strong>
                                                </p>
                                            </div>
                                            <div class="noticies-item__play noticies-item__play--small"></div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <p class="auto-reload" v-if="wsStarted">Atualizando automaticamente</p>
                    </div>
                </div>
            </div>

            <div class="container-fluid container-live-contents">
                <div class="container">
                    
                    <div class="row">
                        <div class="col-12 col-lg-7">
                            <Login v-if="!token" :show_form="show_form" />
                            <div class="live-content">
                                <template v-if="page && token">
                                    <button 
                                        class="novo"
                                        @click="lance_form=true" >
                                        Novo Lance
                                    </button>
                                    <button 
                                        class="novo"
                                        @click="logout()" >
                                        Sair
                                    </button>
                                </template>
                                <div class="automatic-loading" v-if="wsStarted">
                                    <div class="lds-spinner">
                                        <div></div><div></div>
                                        <div></div><div></div>
                                        <div></div><div></div>
                                        <div></div><div></div>
                                        <div></div><div></div>
                                        <div></div><div></div>
                                    </div>
                                </div>
                                <div class="live-content__item " v-for="item in feed" :key="item.id">
                                    <div class="live-content__item-time">
                                        <template v-if="item.minute">
                                            <div class="live-content__item-time-minutes">{{item.minute}}</div>
                                            <div class="live-content__item-time-part">{{item.get_moment_display}}</div>
                                        </template>
                                        <template v-else>
                                            <span class="item-time__unique">{{item.get_moment_display}}</span>
                                        </template>
                                    </div>
                                    <div class="live-content__item-infos">
                                        <template v-if="item.throw_type == 'goal'">
                                            <img src="@/assets/images/icon-socerball.svg">
                                        </template>
                                        <template v-else-if="item.throw_type == 'replacement'">
                                            <img src="@/assets/images/icon-substitution.svg">
                                        </template>
                                        <p v-if="item.title && item.title !== 'null'"><b>{{item.title}}</b></p>
                                        <img v-if="item.image" :src="utils.image(item.image.file, 512, 304)" alt="">
                                        <p v-if="item.text">{{item.text}}</p>
                                        <a 
                                            class="noticies-item noticies-item__live-video"
                                            v-if="item.video" 
                                            @click.prevent="play(item.video)" 
                                            href="" >
                                                <div class="noticies-item--image">
                                                    <img 
                                                        style="margin-bottom:0" 
                                                        :src="utils.image(item.video.thumbnail.file, 512, 304)" />
                                                </div>
                                                <div class="noticies-item__play noticies-item__play--small"></div>
                                        </a>
                                        <span v-if="item.embed" v-html="item.embed"></span>
                                    </div>
                                    <div class="live-content-options" v-if="token">
                                        <a href="#" 
                                            v-if="item.throw_type!='replacement'"
                                            @click.prevent="editar(item.id)">
                                            <img src="@/assets/images/pencil-alt-solid.svg" />
                                        </a>
                                        <a href="#" @click.prevent="confirmaApagar(item.id)">
                                            <img src="@/assets/images/trash-solid.svg" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-5" v-if="page">
                            <div class="live-team-table">
                                <div class="live-team-table__header">
                                    <div class="championship-name">{{page.championship.name}}</div>
                                    <div class="championship-teams">
                                        <div class="championship-teams__left">
                                            <span class="team-name">{{page.team_home.initials}}</span>
                                            <span><img v-if="page.team_home.logo" :src="utils.image(page.team_home.logo.file, 46, 45)"></span>
                                            <span>{{page.score_home}}</span>
                                        </div>
                                        <div class="championship-teams__right">
                                            <span>{{page.score_visitor}}</span>
                                            <span><img v-if="page.team_visitor.logo" :src="utils.image(page.team_visitor.logo.file, 46, 45)"></span>
                                            <span class="team-name">{{page.team_visitor.initials}}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="live-team-table__content">
                                    <div class="live-team-table__content--left">
                                        <div :class="`player-item ${playerStats(player)}`" v-for="player in squad_home" :key="player.player.id">
                                            <span :class="{'player-item__name': true, 'sub': playerReplaced(player)}">
                                                {{player.player.name}}
                                            </span>
                                            <span class="player-item__pos">
                                                {{player.position.name}}
                                            </span>
                                        </div>
                                        <div class="player-item">
                                            <span class="player-item__name">{{page.coaches[0].coach_home.name}}</span>
                                            <span class="player-item__pos">TEC</span>
                                        </div>
                                    </div>

                                    <div class="live-team-table__content--right">
                                        <div :class="`player-item ${playerStats(player)}`" v-for="player in squad_visitor" :key="player.id">
                                            <span class="player-item__pos">
                                                {{player.position.name}}
                                            </span>
                                            <span :class="{'player-item__name': true, 'sub': playerReplaced(player)}">
                                                {{player.player.name}}
                                            </span>
                                        </div>
                                        <div class="player-item">
                                            <span class="player-item__pos">TEC</span>
                                            <span class="player-item__name">{{page.coaches[0].coach_visitor.name}}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="referees">
                                <b>Arbritos do Jogo</b>
                                <ul>
                                    <li v-for="referee in page.referees" :key="referee.id">
                                        {{referee.player.name}} ({{referee.get_role_display}})
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <NotFound v-if="NOT_FOUND" />
        <Error v-if="ERROR" />
        <LanceForm 
            v-if="page && token" 
            :display="lance_form"
            :page_id="page.id" 
            :token="token"
            :teams="teams"
            :squad_home="squad_home"
            :squad_visitor="squad_visitor"
            :squad_home_bench="squad_home_bench"
            :squad_visitor_bench="squad_visitor_bench" />
    </div>
</template>

<script>
import asgi from '@/api/asgi'
import page from '@/api/page'
import utils from '@/utils'

import Login from '@/components/Login'
import LanceForm from '@/components/LanceForm'
import Swiper from 'swiper'

import NotFound from '@/views/NotFound'
import Error from '@/views/Error'

export default {
    name: 'TempoReal',
    components:{LanceForm, Login, NotFound, Error},
    head: {
        title: function() {
            return{
                inner:this.title
            }
        }
    },
    data() {
        return {
            title: '',
            swiper: null,
            page: null,
            feed: null,
            videos:[],
            video_destaque:null,
            utils:utils,
            autoplay: 0,
            token: null,
            squad_home: null,
            squad_home_bench:null,
            squad_visitor: null,
            squad_visitor_bench: null,
            feed_map: {},
            wsStarted: false,
            show_form: false,
            lance_form: false,
            
            NOT_FOUND: false,
            ERROR: false,
        }   
    },
    computed:{
        squad_home_names: function () {
            return this.squad_home.map(value => {
                return value.player.name
            })
        },
        squad_visitor_names: function () {
            return this.squad_visitor.map(value => {
                return value.player.name
            })
        },
        squad_home_map: function () {
            let map = {}
            this.squad_home.forEach((value, index) => {
                map[value.player.id] = index
            }) 
            return map
        },
        squad_visitor_map: function () {
            let map = {}
            this.squad_visitor.forEach((value, index) => {
                map[value.player.id] = index
            }) 
            return map
        },
        squad_home_bench_map: function () {
            let map = {}
            this.squad_home_bench.forEach((value, index) => {
                map[value.player.id] = index
            }) 
            return map
        },
        squad_visitor_bench_map: function () {
            let map = {}
            this.squad_visitor_bench.forEach((value, index) => {
                map[value.player.id] = index
            }) 
            return map
        },
        teams: function () {
            let teams = []

            teams.push({
                key:'home',
                label:this.page.team_home.name,
            })
            teams.push({
                key:'visitor',
                label:this.page.team_visitor.name,
            })

            return teams
        }
    },
    watch:{
        videos: function() {
            const options = {
                autoplay: {
                    slidesPerView: 1,
                    delay: 5000,
                    disableOnInteraction: false
                },
                spaceBetween: 20,
                navigation: {
                    nextEl: '.swiper-button-next--live-slider',
                    prevEl: '.swiper-button-prev--live-slider',
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 4,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    0: {
                        slidesPerView: 2,
                    }
                }
            }
            if (!this.swiper) {
                window.setTimeout(function () {
                    this.swiper = new Swiper(".row-live-slider", options)
                }, 200)
            }
            if(this.swiper){
                this.swiper.update()
            }
        },
        feed: function() {
            if (this.feed) {
                this.feed.forEach((value, index) => {
                    this.feed_map[value.id] = index
                    
                    if (value.embed) {
                        window.twttr.widgets.load();
                    }
                })
            }
        },
    },
    methods:{
        async getTempoReal() {
            // Carrega os dados iniciais do tempo real
            const response = await page.get(`find/?html_path=${this.$route.path}`)

            if (response.ok) {
                this.page = response.data
                this.title = this.page.title
                this.$emit('updateHead')
                this.squad_home = this.page.squad_home
                this.squad_home_bench = this.page.squad_home_bench
                this.squad_visitor = this.page.squad_visitor
                this.squad_visitor_bench = this.page.squad_visitor_bench
                this.feed = this.page.lancealance

                if (this.feed) {
                    if (this.page.status_game !== 'in_progress') {
                        this.feed.reverse()
                    }
    
                    this.feed.forEach(item => { 
                        this.handleFeedItem(item)
                    });
                    
                    if (this.page.status_game === 'in_progress') {
                        this.startRealTime()
                    }
                }
            } else {
                if (response.status === 404) {
                    this.NOT_FOUND = true
                } else if (response.status >= 500) {
                    this.ERROR = true
                }
            }
        },
        handleFeedItem(item, start=false){
            // Computa os dados do jogo de acordo com o item do feed

            if (item.player) {
                this.setPlayerStats(
                    item,
                    this.squad_home, 
                    this.squad_home_bench,
                    'score_home',
                    this.squad_home_names,
                    this.squad_home_map,
                    this.squad_home_bench_map,
                )
                this.setPlayerStats(
                    item,
                    this.squad_visitor, 
                    this.squad_home_bench,
                    'score_visitor',
                    this.squad_visitor_names,
                    this.squad_visitor_map,
                    this.squad_visitor_bench_map,
                )
            }

            // atualiza a lista de videos
            if (item.video) {
                if (start) {
                    this.videos.unshift(item.video)
                } else {
                    this.videos.push(item.video)
                }

                if (!this.video_destaque) {
                    this.video_destaque = item.video
                }
            }

            if (item.embed && start) {
                window.setTimeout(function(){
                    window.twttr.widgets.load();
                }, 1000)
            }

        },
        setPlayerStats(item, squad, bench, score, names, map, bench_map) {
            // Define Gols, Cartões amarelos e vermelhos e substituições
            if (names.includes(item.player.name)) {
                const squad_index = map[item.player.id]
                let player = squad[squad_index]
                if (!Object.hasOwnProperty.call(player, 'attrs')) {
                    squad[squad_index].attrs = []
                }
                squad[squad_index].attrs.push(item.throw_type)
                if (item.throw_type == 'goal') {
                    this.page[score]++
                }

                if (item.throw_type == 'replacement') {
                    let bench_index = bench_map[item.bench.id]
                    let bench_player = bench[bench_index]
                    squad.splice(squad_index+1,0,bench_player)
                    bench.splice(bench_index, 1)
                }
            }
        },
        removeFeed(id){
            const feed_index = this.feed_map[id]
            const feed_item = this.feed[feed_index]
            if(feed_item.player) {

                if (feed_item.throw_type == 'goal') {
                    if (this.squad_home_names.includes(feed_item.player.name)){
                        this.page.score_home--
                    }
                    if (this.squad_visitor_names.includes(feed_item.player.name)){
                        this.page.score_visitor--
                    }
                }

                if (feed_item.throw_type == 'replacement') {
                    if (this.squad_home_names.includes(feed_item.player.name)){
                        let bench_index = this.squad_home_map[feed_item.bench.id]
                        this.squad_home.splice(bench_index, 1)
                    }
                }

                let player_index = this.squad_home_map[feed_item.player.id]
                let player = this.squad_home[player_index]
                
                let attr_index = player.attrs.indexOf(feed_item.throw_type)
                player.attrs.splice(attr_index, 1)
            }
            
            this.feed.splice(feed_index, 1)
        },
        startRealTime() {
            // Cria o WS que alimenta o feed ao vivo
            
            let self = this
            this.wsStarted = true
            const url = `${process.env.VUE_APP_WS}/ws/realtime/${this.$route.params.slug}/`
            const chatSocket = new WebSocket(url)

            chatSocket.onmessage = function(e) {
                // Para cada mensagem recebida o feed é atualizado
                // No caso de novos items a lista é atualizada
                // Quando a mensagem for de remoção atualiza o placar

                const data = JSON.parse(e.data);
                const item = data.message
                if (item.type == 'insert') {
                    self.feed.unshift(item.data)
                    self.handleFeedItem(item.data, true)
                } else if (item.type == 'update') {
                    const feed_index = self.feed_map[item.data.id]
                    self.feed[feed_index] = item.data
                    self.handleFeedItem(item.data, true)
                } else if (item.type == 'delete') {
                    self.removeFeed(item.id)
                }
            };

            // chatSocket.onclose = function() {
            //     window.setTimeout(() => {
            //         self.startRealTime()
            //     },5000)
            // };
        },
        playerStats(player){
            if (Object.hasOwnProperty.call(player, 'attrs')) {
                let filteredAttrs = []
                let findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) != index)
                let duplicates = findDuplicates(player.attrs)

                player.attrs.forEach(attr => {
                    if (duplicates.includes(attr)) {
                        if (attr === 'yellow') {
                            if(!filteredAttrs.includes('red')) {
                                filteredAttrs.push('red')
                            }
                        } else {
                            filteredAttrs.push(attr)    
                        }
                    } else {
                        filteredAttrs.push(attr)
                    }

                })
                
                return filteredAttrs.join(' ')
            }
            return ''
        },
        playerReplaced(player){
            if (Object.hasOwnProperty.call(player, 'attrs')) {
                return player.attrs.includes('replacement')
            }
        },
        play(video){
            this.video_destaque = video
            this.autoplay = 1
            window.scrollTo(0, 0); 
        },
        confirmaApagar(id) {
            let resp = confirm("Deseja apagar?")
            if (resp === true){
                this.apaga(id)
            }
        },
        editar(id) {
            this.$root.$emit('gazetaweb:editlance', id)
        },
        logout() {
            localStorage.removeItem('token')
            this.token = null
        },
        async apaga(id) {
            await asgi.delete(`lancealance/${id}`,{},{
                headers: {
                    Authorization: `Token ${this.token}`
                }
            })
        },
        loadTwitterScript() {
             if (!document.getElementById('twttr-widgets')) {
                const embed = document.createElement('script');
                embed.id = 'twttr-widgets'
                embed.src = 'https://platform.twitter.com/widgets.js';
                document.body.appendChild(embed);
            }
        },
    },
    created(){
        this.getTempoReal()
    },
    mounted() {
        this.loadTwitterScript()

        this.$root.$on('gazetaweb:login', (token) => {
            this.token = token
        })
        this.$root.$on('modal:close', () => {
            this.lance_form = false
        })
        this.$root.$on('modal:open', () => {
            this.lance_form = true
        })

        var googletag = window.googletag
        googletag.cmd.push(function() {
            googletag.destroySlots()
            googletag.defineSlot('/1513505/v1_gweb_superbanner_topo', [[970,250], [300, 100], [728, 90]], 'div-gpt-ad-1603501550614-0').addService(googletag.pubads());
            googletag.pubads().enableSingleRequest()
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices()
            googletag.display('div-gpt-ad-1603501550614-0')
        })
    }
}
</script>

<style>
    .referees{
        text-align:center;
        margin-bottom: 30px;
    }

    .referees ul{
        list-style-type: none;
        margin:0;
        padding:0;
    }
    .live-content-options{
        position: absolute;
        right: 0;
    }
    .live-content-options a{
        font-size: 12px;
        border: 1px solid #ccc;
        background-color: #ddd;
        color: #fff;
        padding: 5px 10px;
        border-radius: 5px;
    }
    .live-content-options a:hover{
        background-color: #aaa;
        text-decoration: none;
    }
    .live-content-options a img{
        width:10px
    }
    .novo{
        float: right;
        border: 1px solid #ccc;
        background-color: #ddd;
        color: #fff;
        padding: 5px 10px;
        border-radius: 5px;
    }
    .novo:hover{
        background-color: #aaa;
        text-decoration: none;
    }
</style>